import { usePlanPageVariant } from "@/react/hooks/usePlanPageVariant";
import { BillingCycleSwitch } from "./BillingCycleSwitch";
import { BillingIntervalRadio } from "./BillingIntervalRadio";

export const BillingIntervalSelector = () => {
  const { isVariantC1Enabled, isVariantC2Enabled } = usePlanPageVariant();

  // Variant C2: Use switch component
  if (isVariantC2Enabled) {
    return <BillingCycleSwitch />;
  }

  // Variant C1: Use radio buttons
  if (isVariantC1Enabled) {
    return <BillingIntervalRadio />;
  }

  // Default: Use switch component as fallback
  return <BillingCycleSwitch />;
};
